export default {
    getList(url, params, self, callback) {
        self.$axios.post(
            url,
            params
        ).then(response => {
            let rs = response.data;
            self.list = rs.data;
            self.total = rs.total;
            if (self.total > 0 && self.list.length <= 0 && self.index !== Math.ceil(self.total / self.size)) {
                self.index--;
                params.index = self.index;
                // 尽量避免递归调用，特殊情况，容易导致服务器崩溃
                this.getListAgain(url, params, self);
            }
            if (callback) callback(response);
        });
    },
    getListAgain(url, params, self) {
        self.$axios.post(
            url,
            params
        ).then(response => {
            let rs = response.data;
            self.list = rs.data;
            self.total = rs.total;
        });
    },
    ajaxDownload(resp, fileName) {
        let blob = new Blob([resp.data], {type: resp.headers['content-type']});
        let downloadElement = document.createElement('a');
        if ('download' in downloadElement) { //非IE
            downloadElement.href = URL.createObjectURL(blob);
            downloadElement.download = fileName; //下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            window.URL.revokeObjectURL(downloadElement.href); //释放blob对象
            document.body.removeChild(downloadElement); //下载完成移除元素
        } else { //IE
            navigator.msSaveBlob(blob, fileName)
        }
    }
}